import { AlertDialog, AlertDialogContent } from '@/components/ui/alert-dialog';
import { Button } from '@/components/Button';
import useBulkDeleteCompanies from '../api/useBulkDeleteCompanies';
import { showSuccessToast, showErrorToast } from '../../job_change_processes/lib/toast';
import type { AgentApiCompaniesIndex } from '@/types/serializers';

type Props = {
  companies: AgentApiCompaniesIndex['records'];
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
};

export default function CompanyBulkDeleteModal({
  companies,
  open,
  onOpenChange,
  onSuccess,
}: Props) {
  const { mutateAsync: bulkDelete, isPending } = useBulkDeleteCompanies();

  const handleSubmit = async () => {
    try {
      await bulkDelete({ ids: companies.map((c) => c.id) });
      showSuccessToast('企業を削除しました');
      onSuccess();
    } catch {
      showErrorToast('企業の削除に失敗しました');
    }
  };

  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="w-[592px]! max-w-[592px]!">
        {/* ヘッダー */}
        <div className="border-b border-solid border-border px-6 py-4">
          <p className="text-heading-xs font-bold">企業データの削除</p>
        </div>

        {/* コンテンツ */}
        <div className="flex flex-col gap-sm px-6 py-4">
          <p className="text-body-md text-main">以下の企業を削除してよろしいですか？</p>
          <div className="flex h-[58px] items-center gap-2 rounded bg-gray px-4">
            <div className="flex size-6 items-center justify-center rounded-full border border-solid border-border bg-white text-heading-3xs font-bold text-main">
              {companies.length}
            </div>
            <p className="truncate text-body-sm text-main">
              {companies.map((c) => c.name).join(', ')}
            </p>
          </div>
        </div>

        {/* フッター */}
        <div className="flex items-center justify-end gap-4 border-t border-solid border-border px-6 py-4">
          <Button type="button" color="secondary" size="md" onClick={handleClose}>
            キャンセル
          </Button>
          <Button
            type="button"
            color="danger"
            size="md"
            onClick={handleSubmit}
            disabled={isPending}
            className={isPending ? 'opacity-50' : ''}
          >
            削除する
          </Button>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
